
import { useState } from 'react';

const faqData = [
  {
    question: 'DMM FXが倒産したら資金はどうなりますか？',
    answer:
      '全額信託保全により、お客様の資産は信託銀行から返還されます。DMM.com証券の経営状態に関わらず、お客様の資産は完全に保護されています。信託先は日証金信託銀行、SMBC信託銀行、FXクリアリング信託の3社です。',
  },
  {
    question: '海外FX業者と比べて安全ですか？',
    answer:
      'はい、圧倒的に安全です。DMM FXは日本の金融庁に登録された国内業者で、厳格な規制と監督下で運営されています。信託保全も法律で義務付けられており、海外の無登録業者のような出金トラブルのリスクはほぼありません。',
  },
  {
    question: '個人情報が漏洩する心配はありませんか？',
    answer:
      'SSL暗号化通信や厳格なアクセス管理など、最新のセキュリティ対策を実施しています。二段階認証にも対応しており、個人情報保護には万全を期しています。',
  },
  {
    question: 'FXで借金を背負うことはありますか？',
    answer:
      'DMM FXにはロスカット（強制決済）の仕組みがあり、証拠金維持率が一定水準を下回ると自動的にポジションが決済されます。ただし、急激な相場変動時には口座残高がマイナスになる可能性もゼロではありません。余裕資金で取引し、適切な損切り設定を行うことが重要です。',
  },
  {
    question: '初心者でも本当に大丈夫ですか？',
    answer:
      'はい、DMM FXは初心者向けのサポートが充実しています。デモ取引で無料練習ができ、24時間の電話・LINEサポートもあります。少額から始めて、徐々に経験を積んでいけば問題ありません。',
  },
  {
    question: 'DMM FXのロスカットルールを教えてください',
    answer:
      'DMM FXでは、証拠金維持率が50%を下回った場合にロスカット（強制決済）が執行されます。これはお客様の資産を守るための安全装置です。証拠金維持率に余裕を持った取引を心がけましょう。',
  },
];

export default function FaqSection() {
  // Removed TypeScript‑specific generic from useState to keep the file valid JavaScript/JSX
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-teal-100 rounded-lg mb-4">
            <i className="ri-question-answer-line text-2xl text-teal-600"></i>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">よくある質問</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            DMM FXの安全性に関して、よく寄せられる質問にお答えします。
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-50/50 transition-colors"
                aria-expanded={openIndex === i}
                aria-controls={`faq-answer-${i}`}
              >
                <span className="flex items-start pr-4">
                  <i className="ri-question-line text-teal-600 text-lg mr-3 mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                  <span className="text-base font-semibold text-gray-900">{faq.question}</span>
                </span>
                <i
                  className={`ri-arrow-down-s-line text-xl text-gray-400 transition-transform duration-300 w-5 h-5 flex items-center justify-center flex-shrink-0 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              <div
                id={`faq-answer-${i}`}
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
                aria-hidden={openIndex !== i}
              >
                <div className="px-6 pb-5 ml-8">
                  <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
